import { useGet } from "@albertine/api-client";
import type { MemberGroup as MemberGroupResource } from "@albertine/types/openapi";
import type { Group } from "../types/Group";

export function useMemberGroups() {
    return useGet(
        "listMemberGroups",
        {},
        {
            select: (response) => response.results.map(toGroup),
        },
    );
}

function toGroup(group: MemberGroupResource): Group {
    return {
        id: group.id,
        displayName: group.displayName,
        ...(group.description !== null ? { description: group.description } : {}),
    };
}
